import { Module, VuexModule, Action } from 'vuex-module-decorators';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import {
  BASE_URL,
  USER_SEAMLESS_PROBLEM_ADD,
  USER_SEAMLESS_PROBLEM_FETCH,
  USER_SEAMLESS_PROBLEM_REMOVE,
  USER_SEAMLESS_PROBLEM_SEARCH,
  M_POST,
  M_DELETE
} from '@/utils/api';

import type { IUserSeamlessProblemResponse, IUserSeamlessProblemRequest } from '@/interface/Admin';

@Module({ name: 'admin' })
export default class Admin extends VuexModule {
  userList: Array<IUserSeamlessProblemResponse> = [];

  @Action({ rawError: true })
  async AddUser(user: IUserSeamlessProblemRequest) {
    try {
      const { data } = await axios({
        url: BASE_URL + USER_SEAMLESS_PROBLEM_ADD,
        data: user,
        method: M_POST
      });

      assertOk(data, 'Add user failed');
      return data;
    } catch (err) {
      throw toError(err, 'Add user failed');
    }
  }

  @Action({ rawError: true })
  async SearchUser(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + USER_SEAMLESS_PROBLEM_SEARCH,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Search user failed');
      return data;
    } catch (err) {
      throw toError(err, 'Search user failed');
    }
  }

  @Action({ rawError: true })
  async removeUser(user: IUserSeamlessProblemRequest) {
    try {
      const { data } = await axios({
        url: BASE_URL + USER_SEAMLESS_PROBLEM_REMOVE,
        data: user,
        method: M_DELETE
      });

      assertOk(data, 'Remove user failed');
      return data;
    } catch (err) {
      throw toError(err, 'Remove user failed');
    }
  }

  @Action({ rawError: true })
  async FetchUser(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + USER_SEAMLESS_PROBLEM_FETCH,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch user failed');
      return data;
    } catch (err) {
      throw toError(err, 'Fetch user failed');
    }
  }
}
